
<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000px" transition="dialog-transition" >
      <template v-slot:activator="{on}">
        <v-btn v-on="on" small color="primary" icon><v-icon>mdi-information</v-icon></v-btn>
      </template>

      <v-card v-if="dialog" style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Detalhes do cheque</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <template v-if="loading">
            <v-alert type="info" :value="true">
              Carregando... 
              <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
            </v-alert>
          </template>
          <template v-if="!loading && !local_returned.id">
            <v-alert type="error" :value="true">
              Registro não encontrado!
            </v-alert>
          </template>
          <template v-if="!loading && local_returned.id">
            <div class='title'>
              <span><b class="font-weight-black">Método de devolução:</b></span>
              <span class="ml-2 font-weight-light">{{returned_with}}</span>
            </div>
             <div class='title'>
              <span><b class="font-weight-black">Relatado por</b></span>
              <span class="ml-2 font-weight-light">{{local_returned.returned_by || '---'}}, </span>
              <span><b class="font-weight-black"> em:</b></span>
              <span class="ml-2 font-weight-light">{{displayDate(local_returned.created_at)}}</span>
            </div>

            <div class='title' v-if="local_returned.confirmed_update ? Object.keys(local_returned.confirmed_update).length : false">
              <span><b class="font-weight-black">Validado por</b></span>
              <span class="ml-2 font-weight-light">{{local_returned.confirmed_update.user}}, </span>
              <span><b class="font-weight-black"> em</b></span>
              <span class="ml-2 font-weight-light">{{displayDate(local_returned.confirmed_update.at)}}</span>
            </div>
            
            <div class='title' v-if="local_returned.handed_update ? Object.keys(local_returned.handed_update).length : false">
              <span><b class="font-weight-black">Em mãos por</b></span>
              <span class="ml-2 font-weight-light">{{local_returned.handed_update.user}}, </span>
              <span><b class="font-weight-black"> em</b></span>
              <span class="ml-2 font-weight-light">{{displayDate(local_returned.handed_update.at)}}</span>
            </div>
            <div class='title' v-if="local_returned.payed_update ? Object.keys(local_returned.payed_update).length : false">
              <span><b class="font-weight-black">Pago por</b></span>
              <span class="ml-2 font-weight-light">{{local_returned.payed_update.user}}, </span>
              <span><b class="font-weight-black"> em</b></span>
              <span class="ml-2 font-weight-light">{{displayDate(local_returned.payed_update.at)}}</span>
            </div>
            
            <div class='title' v-if="local_returned.sent_update ? Object.keys(local_returned.sent_update).length : false">
              <span><b class="font-weight-black">Enviado por</b></span>
              <span class="ml-2 font-weight-light">{{local_returned.sent_update.user}}, </span>
              <span><b class="font-weight-black"> em</b></span>
              <span class="ml-2 font-weight-light">{{displayDate(local_returned.sent_update.at)}}</span>
            </div>
            
            <div class='title' v-if="local_returned.concluded_by && local_returned.status == 'concluded'">
              <span><b class="font-weight-black">Concluído por</b></span>
              <span class="ml-2 font-weight-light">{{local_returned.concluded_by}}, </span>
              <span><b class="font-weight-black"> em</b></span>
              <span class="ml-2 font-weight-light">{{displayDate(local_returned.updated_at)}}</span>
            </div>
          </template>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn close @click="dialog=false"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: "DialogReturnedDetails",
  props: {
    check: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      local_returned: {}
    }
  },
  methods: {
    getDetails() {
      this.loading = true
      Api.ReturnedCheck.show(this.check.id).then(r=> r.data).then(d=>{
        d = d.data? d.data.attributes : d
        this.local_returned = d? {...d} : {}
      }).catch((err) => {
        console.log(err);
      }).finally(()=>{
        this.loading = false
      })
    },
    displayDate(date){
      date = date.split('T')
      return this.$moment(date[0]+'T'+date[1]).subtract(3, 'hour').format('lll')
    },
  },
  computed: {
    returned_with() {
      let by = null
      if (this.local_returned.id){
        if (!by) by = this.local_returned.check_id && 'Cheque'

        if (!by) by = this.local_returned.deposit_id && 'Depósito'

        if (!by) by = this.local_returned.client_id && 'Manual'

      }
      return by
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        this.getDetails()
      } else if (nv == false){
        this.local_returned = {}
      }
    }
  },
}
</script>